import {Component} from "react";
import * as React from "react";
import {BoxedSelectList} from "./BoxedSelectList"


class BoxedYesNo extends Component {
    list = {
        nameL: this.props.name,
        options: [{name:"YES", text:"Yes"},{name:"NO", text:"No"}],
        hasOther: false,
        label: this.props.label
    }

    render() {
        return <BoxedSelectList {...this.list} {...this.props} onValueChanged={this.props.onValueChanged} />
    }
}

export {BoxedYesNo}